import { isSameAddress } from "web3/helpers/address"

// TODO: Move banned addresses to the backend since this map can be viewed 
// and manipulated in the browser, making it a security risk

// List of banned addresses with `as const` assertion
// The `as const` makes the array and its contents readonly at compile time,
// providing better type safety and preventing accidental modifications.
// Without it, TypeScript would infer string[] instead of the exact literal types.
export const BANNED_ADDRESSES = [
  "0x098B716B8Aaf21512996dC57EB0615e2383E2f96",
  "0xa0e1c89Ef1a489c9C7dE96311eD5Ce5D32c20E4B",
  "0x3Cffd56B47B7b41c56258D9C7731ABaDc360E073",
  "0x53b6936513e738f44FB50d2b9476730C0Ab3Bfc1",
  "0x35fB6f6DB4fb05e6A4cE86f2C93691425626d4b1",
  "0xF7B31119c2682c88d88D455dBb9d5932c65Cf1bE",
  "0x3e37627dEAA754090fBFbb8bd226c1CE66D255e9",
  "0x08723392Ed15743cc38513C4925f5e6be5c17243",
  "0x7F367cC41522cE07553e823bf3be79A889DEbe1B",
  "0xd882cfc20f52f2599d84b8e8d58c7fb62cfe344b",
  "0x901bb9583b24d97e995513c6778dc6888ab6870e",
  "0xa7e5d5a720f06526557c513402f2e6b5fa20b008",
  "0x8576acc5c05d6ce88f4e49bf65bdf0c62f91353c",
  "0x1da5821544e25c636c1417ba96ade4cf6d2f9b5a",
  "0x7Db418b5D567A4e0E8c59Ad71BE1FcE48f3E6107",
  "0x72a5843cc08275C8171E582972Aa4fDa8C397B2A",
  "0x7F19720A857F834887FC9A7bC0a0fBe7Fc7f8102",
  "0x9f4cda013e354b8fc285bf4b9a60460cee7f7ea9",
  "0x3cbded43efdaf0fc77b9c55f6fc9988fcc9b757d",
  "0x2f389ce8bd8ff92de3402ffce4691d17fc4f6535",
  "0x19aa5fe80d33a56d56c78e82ea5e50e5d80b4dff",
  "0xe7aa314c77f4233c18c6cc84384a9247c0cf367b",
  "0x308ed4b7b49797e1a98d3818bff6fe5385410370",
  "0x67d40EE1A85bf4a4Bb7Ffae16De985e8427B6b45",
  "0x6f1ca141a28907f78ebaa64fb83a9088b02a8352",
  "0x48549a34ae37b12f6a30566245176994e17c6b4a",
  "0x5512d943ed1f7c8a43f3435c85f7ab68b30121b0",
  "0xc455f7fd3e0e12afd51fba5c106909934d8a0e4a",
  "0xfec8a60023265364d066a1212fde3930f6ae8da7",
  "0x7FF9cFad3877F21d41Da833E2F775dB0569eE3D9",
  "0xc2a3829F459B3Edd87791c74cD45402BA0a20Be3",
  "0x3AD9dB589d201A710Ed237c829c7860Ba86510Fc",
  "0x83E5bC4Ffa856BB84Bb88581f5Dd62A433A25e0D",
  "0x08b2eFdcdB8822EfE5ad0Eae55517cf5DC544251",
  "0x04DBA1194ee10112fE6C3207C0687DEf0e78baCf",
  "0x0Ee5067b06776A89CcC7dC8Ee369984AD7Db5e06",
  "0x502371699497d08D5339c870851898D6D72521Dd",
  "0x5A14E72060c11313E38738009254a90968F58f51",
  "0xEFE301d259F525cA1ba74A7977b80D5b060B3ccA",
  "0xd0975b32cea532eadddfc9c60481976e39db3472",
  "0x1967d8af5bd86a497fb3dd7899a020e47560daaf",
  "0x39D908dac893CBCB53Cc86e0ECc369aA4DeF1A29",
  "0x4f47bc496083c727c5fbe3ce9cdf2b0f6496270c",
  "0x38735f03b30FbC022DdD06ABED01F0Ca823C6a94",
  "0x97b1043abd9e6fc31681635166d430a458d14f9c",
  "0xb6f5ec1a0a9cd1526536d3f0426c429529471f40",
  "0xe1d865c3d669dcc8c57c8d023140cb204e672ee4",
  "0x9c2bc757b66f24d60f016b6237f8cdd414a879fa",
  "0xdcbEfFBECcE100cCE9E4b153C4e15cB885643193",
  "0x5f48c2a71b2cc96e3f0ccae4e39318ff0dc375b2",
  "0x5a7a51bfb49f190e5a6060a5bc6052ac14a3b59f",
  "0xed6e0a7e4ac94d976eebfb82ccf777a3c6bad921",
  "0x797d7ae72ebddcdea2a346c1834e04d1f8df102b",
  "0x931546D9e66836AbF687d2bc64B30407bAc8C568",
  "0x43fa21d92141BA9db43052492E0DeEE5aa5f0A93",
  "0x6be0ae71e6c41f2f9d0d1a3b8d0f75e6f6a0b46e",
  "0x530a64c0ce595026a4a556b703644228179e2d57",
  "0x983a81ca6FB1e441266D2FbcB7D8E530AC2E05A2",
  "0x961c5be54a2ffc17cf4cb021d863c42dacd47fc1",
  "0xfac583c0cf07ea434052c49115a4682172ab6b4f",
  "0xE950DC316b836e4EeFb8308bf32Bf7C72a1358FF",
  "0x21B8d56BDA776bbE68655A16895afd96F5534feD",
  "0x175d44451403Edf28469dF03A9280c1197ADb92c",
  "0xf3701f445b6bdafedbca97d1e477357839e4120d",
  "0x19F8f2B0915Daa12a3f5C9CF01dF9E24D53794F7",
  "0x0931cA4D13BB4ba75D9B7132AB690265D749a5E7",
  "0x1999ef52700c34de7ec2b68a28aafb37db0c5ade",
  "12QtD5BFwRsdNsAZY76UVE1xyCGNTojH9h",
  "1Kuf2Rd8mDyAViwBozGTNYnvWL8uYFrkVo",
  "13f59kUM5FU8MfTG7DCEugYarDhSD7XCoC",
  "1P3ZfGFLezzYGg9k5SVzQmnjyh7nrUmF2y",
  "1EpMiZkQVekM5ij12nMiEwttFPcDK9XhX6",
  "1JREJdZupiFhE7ZzQPtASuMCvvpXC7wRsC",
  "149w62rY42aZBox8fGcmqNsXUzSStKeq8C",
  "1AjZPMsnmpdK2Rv9KQNfMurTXinscVro9V",
  "17ezuJoT3XBbdcwFZbkTnrXbup11F4uhiy",
  "1DH2xDH7TngrDU6LXciprKCBKNcPA1xX8A",
  "33Kja69SQVc8kozpoP7Qw6HFtGxHkiWzTz",
  "3MkUNScqf21EcfWq6T4x2MFgBeSTqhB5t6",
  "LaizKtS5DUhPuP1nTQcc83MS7HwK6vk85z",
  "18uKfaUjgG52rVeXEi3wxnveww7zZuECtE",
  "134r8iHv69xdT6p5qVKTsHrcUEuBVZAYak",
  "15YK647qtoZQDzNrvY6HJL6QwXduLHfT28",
  "1PfwHNxUnkpfkK9MKjMqzR3Xq3KCtq9u17",
  "14kqryJUxM3a7aEi117KX9hoLUw592WsMR",
  "1F2Gdug9ib9NQMhKMGGJczzMk5SuENoqrp",
  "3F2sZ4jbhvDKQdGbHYPC6ZxFXEau2m5Lqj",
  "1AXUTu9y3H8w4wYx4BjyFWgRhZKDhmcMrn",
  "1Hn9ErTCPRP6j5UDBeuXPGuq5RtRjFJxJQ",
  "1EfMVkxQQuZfBdocpJu6RUsCJvenQWbQyE",
  "17UVSMegvrzfobKC82dHXpZLtLcqzW9stF",
  "39eboeqYNFe2VoLC3mUGx4dh6GNhLB3D2q",
  "39fhoB2DohisGBbHvvfmkdPdShT75CNHdX",
  "3E6rY4dSCDW6y2bzJNwrjvTtdmMQjB6yeh",
  "3EeR8FbcPbkcGj77D6ttneJxmsr3Nu7KGV",
  "3HQRveQzPifZorZLDXHernc5zjoZax8U9f",
  "3JXKQ81JzBqVbB8VHdV9Jtd7auWokkdPgY",
  "3KHfXU24Bt3YD5Ef4J7uNp2buCuhrxfGen",
  "3LbDu1rUXHNyiz4i8eb3KwkSSBMf7C583D",
  "3MN8nYo1tt5hLxMwMbxDkXWd7Xu522hb9P",
  "3N6WeZ6i34taX8Ditser6LKWBcXmt2XXL4",
  "1Q9UAQbcDezmyouFrzt94t4dSMxgsUfW1X",
  "1Kys8fqDen8NGFUJ6AFcXfFW5qquuTH4eh",
  "1Q6saNmqKkyFB9mFR68Ck8F7Dp7dTopF2W",
  "1DDA93oZPn7wte2eR1ABwcFoxUFxkKMwCf",
  "LNwgtMxcKUQ51dw7bQL1yPQjBVZh6QEqsd",
  "t1g7wowvQ8gn2v8jrU1biyJ26sieNqNsBJy",
  "XnPFsRWTaSgiVauosEwQ6dEitGYXgwznz2",
  "GPwg61XoHqQPNmAucFACuQ5H9sGCDv9TpS",
  "12udabs2TkX7NXCSj6KpqXfakjE52ZPLhz",
  "Leo3j36nn1JcsUQruytQhFUdCdCH5YHMR3",
  "1DT3tenf14cxz9WFNxmYrXFbB6TFiVWA9U",
  "Xs3vzQmNvAxRa3Xo8XzQqUb3BMgb9EogF4",
  "1Fz29BQp82pE3vXXcsZoMNQ3KSHfMzfMe3",
  "LWnbjLYUfqeokfbWM4FcU7uk2FP2DSxuWS",
  "1AeSq93WDNdLoEJ92sex7T8xQZoYYm8BtS",
  "LaYUy1DGfVSuSF5KbPhbLrm8kRotqiwUJn",
  "t1WSKwCDL1QYRRUrCCknEs5tDLhtGVYu9KM",
  "1AoxtfiBQ22DvbhqAN9Ctb8sULMRhrdwTr",
  "18Qj1THHuETfYhuRDZycXJbWwDMGw73Poa",
  "1MnbhWe5wr7Ut45ReyQsm96PwnM9jD7KaH",
  "1DYFJ6CuBvrxyoQSuBzVsNcetY9tvdsrag",
  "15Pt4NwZaUmMUwS2bQbyyncc7mzgWShtv8",
  "1PhqQpaGCrqSxQ6QDXcv14QCd1U98Zp34E",
  "13YBQr2Cp1YY3xqq2qngaPb7ca1o4ugeq6",
  "1KgudqxMfYaGzqAA7MS4DcsqejtMteqhix",
  "1FRyL9gmFGbzfYDAB4iY9836DJe3KSnjP9",
  "1DbShx4r8i2XesthoDBf5EkYWz5dsKEusV",
  "12sjrrhoFEsedNRhtgwvvRqjFTh8fZTDX9",
  "1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ",
  "19D8PHBjZH29uS1uPZ4m3sVyqqfF8UFG9o",
  "1EYitrwBYNWuTBcjZFbEUdqHppe2raLpaF",
  "1G9CKRHA3mx22DoT1QyNYrh85VSQ19Y1em",
  "182NGZbPJXwg2WDrhrPpR7tpiGQkNPF844",
  "1NayLEVF3bEEbDtdF2Cwso1VdEtvVNh2qX",
  "16PhXY3hNNMTo8kpuJx2emh713KbWpkqci",
  "1GqChmWqGtsaLrGbHfgdrV5Nkvahtjjuxr",
  "18Ke1QWE9nQfXuhJijHggZuPJ5ZYxapoBK",
  "1QJUiNsNfji6mR1FjAwf6Eg9NxxHPoxpWL",
  "1DtGgdCi9VPKz2Bpq8GQhUQEPnQ5HwaT9n",
  "18M8bJWMzWHDBMxoLqjHHAffdRy4SrzkfB",
  "LQAhYwwK5AR1JQiQPr7vu8Pu4b6qcxxvNB",
  "LgwmgYnraU2uBWHVFUDgAmFCPYj5Yw8C9L",
  "LeKvNdNEzgQkzVVnRdV3fAu2DSF1nLsNw6",
  "1KSAbh5trMCTZwhiNsuUQvfTtSSTT8zqRk",
  "1BiUFjzH6wsT73U3tfy4aXHCQsYQHzjk5h",
  "DFFJhnQNZf8rf67tYnesPu7MuGUpYtzv7Z",
  "XyARKoupuArYtToA2S6yMdnoquDCDaBsaT",
  "t1MMXtBrSp1XG38Lx9cePcNUCJj5vdWfUWL",
  "3Gbs4rjcVUtQd8p3CiFUCxPLZwRqurezRZ",
  "17a5bpKvEp1j1Trs4qTbcNZrby53JbaS9C",
  "TLNRT524dzL5FF1nJHDhYEMFpeWjLjRbz1",
  "THh5woR8qfmDsNknQ3agPYzQSiRtMnKsTh",
  "TV5ZTpKDszLTF6XcMnPongS33pwBgF91by",
  "TTAHMdqoom4f2VTWniroPWQHcTRZ4caoH4",
  "TFFvv7NAWmbcVfA7QN81mMvUC25TWj1WJx",
  "1JPfVv5cWRLx1js9NWxg46dG2CGbeRz4th",
  "12HQDsicffSBaYdJ6BhnE22sfjTESmmzKx",
  "1L4ncif9hh9TnUveqWq77HfWWt6CJWtrnb",
  "13mnk8SvDGqsQTHbiGiHBXqtaQCUKfcsnP",
  "1Edue8XZCWNoDBNZgnQkCCivDyr9GEo4x6",
  "1ECeZBxCVJ8Wm2JSN3Cyc6rge2gnvD3W5K",
  "1J9oGoAiHeRfeMZeUnJ9W7RpV55CdKtgYE",
  "1295rkVyNfFpqZpXvKGhDqwhP1jZcNNDMV",
  "1LiNmTUPSJEd92ZgVJjAV3RT9BzUjvUCkx",
  "1LrxsRd7zNuxPJcL5rttnoeJFy1y4AffYY",
  "1KUUJPkyDhamZXgpsyXqNGc3x1QPXtdhgz",
  "1CF46Rfbp97absrs7zb7dFfZS6qBXUm9EP",
  "1Df883c96LVauVsx9FEgnsourD8DELwCUQ",
  "1B64QRxfaa35MVkf7sDjuGUYAP5izQt7Qi",
  "16iWn2J1McqjToYLHSsAyS6En3QA8YQ91H",
  "3E7YbpXuhh3CWFks1jmvWoV8y5DvsfzE6n",
  "3LtcaPbCj87CwJHnRX3vh7c2y9RZQqeSy8",
  "3NRJ8aXdUiZdHaiFX9ePX3DhGHzcEi14Fq",
  "3K7PMJyMNVnxqsfpmK9r9nJDtzDw9wNwNV",
  "3H3rh85qPaGLy2w6618yZNaH7i8asHv46B",
  "3MTrJTFhYK9v1C6pjHtuweZSopfZa4b1wb",
  "347QFbejDBdMZFTxpmn6evvvqyXiqZTCd7",
  "33xWfziVZesgo83U5izdNCBVTnrtBpSwK7",
  "32wdqwX3zCEX3DhAVEcKwXCEGdzgBnx1R9",
  "3N9YcPBDky9UsMx1RTk33tL4jDkZfSnsPk",
  "3M7CGBPUJwXXSroWuZ6H5jiprdKCyf7V5M",
  "34kWCKF2wCbe6uinit2uL4ND6d8yxsuxKM",
  "32VgTk8kGvBsqkHhkvtNooGdtqZm46jTVo",
  "3NPognMSbzyA2JYW2fpkVKWyBMi2XTq2Zt",
  "3MzLtBQ4Lz9J6w4Qu55TktgxFKZwxYWrP6",
  "36YGN5dGzqrxMomTHdkT6cYVMnWBw8S7hD",
  "39KQvziHwUe2vddbpfC5WkQEV72qbQhxuh",
  "3Qw9Fn19gCnga9LfHfpM99aGzuqxBNjR2i",
  "rnXyVQzgxZe7TR1EPzTkGj2jxH4LMJYh66",
  "158treVZBGMBThoaympxccPdZPtqUfYrT9",
  "389Sft4nJFkPGhbagk9FN4jXncA9piYTuU",
  "39Te8MbphSgs7npDJPj2hbNzhke61NTcnB",
  "31p6woV4e55HUfC2aGynFhzQnGoJFW26cD",
  "3DNsaQnaUz7wkQny1ZDSmtz6QfbEShxoDD",
  "3AjyprBY5yhijiCjUC5NUJutGbwhd3AQdE",
  "35QpLWYkvD3ALhjbge5bK2kd7HfHYcDMu3",
  "3NQ1aa9ceirMJ1JvRq3eXefvXj1L639fzX",
  "3BsyZ7qRFSi3NsaoV1Ff724qAgrEpjVUHm",
  "372Wk9NLrMkJzKgqJdatWJy4bYRfxFjgat",
  "3Lpoy53K625zVeE47ZasiG5jGkAxJ27kh1",
  "3E6ZCKRrsdPc35chA9Eftp1h3DLW18NFNV",
  "3K4rjdh8A5yi6LWvft2rbmyZvqEbPSSSX4",
  "17mhyeBX617ABZ1ffThhUTJkHUcMvCkfd5",
  "35qwVtMEohWDdBWRiCSR7azoP5cbY8SG1Q",
  "35KAdTa2vqnJzitF2xiUzZn1Gmcas2Y465",
  "35LScRJ8hzDvvWh9t9UA8bHGnGNVz3YEfa",
  "1PJp8diNa89cVHpiT1VPu7EQ8LxYM5HX6v",
  "17V7THwHMiDJmDwZK4unhE5HgKFJKx7VCe",
  "3PiCnZrBvGfWAKQ9hr4cCpfaDjy64yNSpE",
  "14gM1HuLVDELNHaFU22qpabjtiWek4HhV1",
  "1GYuu9d5HPikafbys3k5Q3DRJq6debGsoB",
  "3GXdtA6kbb4M5aqzZm5qqxcFDFRMW8LqdJ",
  "1B11Ezqg3AXjFhMdRq5UpPDpNyriYNVtkn",
  "16SPDQFFzgsoNSPiFFTfS8Dw8LLXqia4oc",
  "19pPbUDvoSBZafkUCYkD2Z9AkuqqV6sWm7",
  "3BQACtiMXYB9JpUMpkEWt9m8BzswpGHq4X",
  "1DGsY4ww3BJnWXTsnmTgWa6UWdoRXgA1pX",
  "1GcKLUUXodTQcLcPD7VLMgvCc4hs5Q775",
  "1EvhBad5wCZYhBoAsGaciV6AvmZ1osLpeJ",
  "12VrYZgS1nmf9KHHped24xBb1aLLRpV2cT",
  "1NbGwQwt4uEhg2srAKppLf8QaF6fbp3PZG",
  "13LQJQ1oJ9K7PsqsGfjNhoVv6UeU6hgzQz",
  "1CG1aSCxUnbmv9G34ofxTQoHtuVnMLJtQV",
  "3Kp8Qc5z7yevDeoQxhS5RSSKnEi5x7AQ43",
  "331TS6DyASY7iU5CRA8UryBnkPS78fP2B1",
  "1NvJm3jfZxENNyqws5BKQvhkLxg9chLJdo",
  "1Licqjca74n8pmNaoARXLLqcTUTHFpxbXH",
  "175BUqf8JCU1uoG1iTRKTacDa4uvJDUCw2",
  "1ANpca7g93BwptUJg1zV116v49zn9gjDi3",
  "1BCWMwpR4M1nYUuuYe2bmzrNuwGoF9ZAbA",
  "18cFGAdYcvNHkuhXLBE7izQKCyUW8TzCJE",
  "1QHxyuLGRMHfbNPJikV4Dwhfx45HWfUMWB",
  "1GnFTy5F9qi5MfaRZfgdg2jkyT5xtAHvd8",
  "16p2UWTZwXRyK5bTHNVjdDyy1D3EQGsZf2",
  "1CddRqw7oSPrT4tt5oXKyx2LiHJDPszy7y",
  "1Hhe61Bwxs8Hd2WxzWY9FQyZicBiZGeSNW",
  "1D3GuaS9eqKw8dWj9JFQtNufdRtysjSLxZ",
  "1PWRKxkR5AU7Tc9zPqjdhtu1eGW1QZzs4y",
  "1D1ej7zQzywWBDNXKNYpmH7Hso2U9koDG4",
  "3KGQ3hX6eFYtBjTBFSdvdkzHmwZyYWLRQh",
  "1LKE3XA9bf5JFqtGtCHzWj5QGxKGwMfXZw",
  "1MtsQsw6n2jvJCWhpCw7jifTfD9Q3rBBVg",
  "1KkaKujnqwJf7Cbm7JKAZGF3X9d4685m8n",
  "1Ge8JodC2HiBiEuT7D3MoH6Fak6XrcT9Kf",
  "1E9uUnLbyfToazo95vmM3ysYnzgkrL7GeC",
  "1HH8eiuaTMucTNyvGCUmAvmCZCtdMi8SqK",
  "19FQzHibWDhSP8pKmJS3uagFYoisXtehzw",
  "3DLGfN7hgsWXXSp9euXcnmWXLpFQuswW2t",
  "1PXxwPVtYxZiCRp9LKq7aKMDFrhAQztvUE",
  "1Q4tJjH2aBr3AJrzxqa4Z3jPpf5SDgF4jK",
  "1PYtgFS2t6i57WdDvbRa7kPcsagGMBxzfg",
  "16ZSAEfYpPCj3D94fsNt2okYj9Ue8mxy6T",
  "3QVyoH4u3qT88uChAeJVhfB3r6maZt431y",
  "1FFS6pX1TCKTNy668Mbk2Lyoem1qB48kYX",
  "1Dpddb1TMjvmNQeYDqgyd1ww6cmwPJRdSk",
  "3AjiWiUdKB5mcGUSS9mBeoHCeYJw3Zo8r6",
  "1EtMuBPQnPCa3cecerdSH1SzydxnhbTmw",
  "3CCmt5LjQ5yKkaFY1DWC2SbERVEtWRnSRD",
  "1MQBDeRWsiJBf7K1VGjJ7PWEL6GJXMfmLg",
  "1MbtT2ZsTtLp7EKZUV9r74cTyqvsMtTP2M",
  "36yS87PLuW7sErLg1TY26WzaVarTim7AcC",
  "3AYU365Tcjef7j9pdKF9Xe8rWpEpsH196t",
  "148LKmyZT3FGE4x1GjsFN6RsAwcjzk5iuE",
  "16EKTes8ahD8xvwisqjc2xSNLiG3fDHatW",
  "3GuQjr7kkrR5EjpanMgyAuxuLgrjEUwe21",
  "35eanEz5iYg2eYaxCtMrR4SCoypFqrBWUH",
  "3QWUdP5taP4GrRuueVDud1eWetb7hc3wDH",
  "3Czhm6xqn8odwz6jgTcjRrUjog28v6aVS8",
  "1F7UL41qYm6TvnExZzPHBCyeENvX3XDEMS",
  "123WBUDmSJv4GctdVEz6Qq6z8nXSKrJ4KX",
  "3BCN3WgMRJwULTz1vsEQ7NZrBjwaUBf5Ca",
  "35SwVFxosV3AsvnrBfzdXarqavRbvDyyxv",
  "32pCmCWEjwhkLwh5BgLNAeBQFp5Gi1hv81",
  "1G64TFMFVJTjhJXra6x74BBhsfSyiWaFtT",
  "1A3iYY4c3dkgNYGewzYzr7EsqfBuWXibGo",
  "3GAUBtrTtWp1D9yeXgr3wMg8B599QHa5m5",
  "3HJN4jRa4mdfkey9JR9jUhr86yPwL86A3C",
  "1EuUMPBCZtSd5pVVFEqmRqUSfU1qy6ASuL",
  "1Pu1nAW7kCoSMThMs8QcpM8JxuByQDZgH",
  "3QnWE5GVfQu3wVav91RuFkqip4Ti4NWqAY",
  "1CNbhgxGRZvsWnEHotfXge7k2E1UPzBDC7",
  "3HSZc4BLnQBznjSq7JvXgqNCZUUs3M9fZz",
  "37dDBCexFPraKW4jGSqkE3NyG52YeZQbJx",
  "1H8sDTTgJPBKw83EBZDLhXvetCbxZUMMZM",
  "1BvJRBRp9ZZ6zLyuZaZsV7g3xP6JokdZQW",
  "34dxZvijpBM1YkPybczbQ7DuGuKAnULdfS",
  "1GkLN7DbA9mAtHNzQWNPANcdWbefaz4Gzm",
  "13hfsQm6oCaDZehfYBSMFiJVAi1jsL6sQd",
  "1Sf6e4xQv8muMZqYPTdRFf3e5o5eWcg9F",
  "1B3u21itzjgKtm7QsNQNCBpSkwzzeDHqrW",
  "3JhPsVV3KnL9dBYGSZALS9EbrLr97R865a",
  "1HuYfoEwsfHgZiRhbhJrCd5ST3iksa8KEx",
  "1J9wJH2bamZVxscXAvoDH4jvtGKb7sYFDm",
  "34WWXwFKAsXL9zYxbeNPaPV6vDamkjQLUo",
  "3PDmRwotTkRAFRLGTUrucCERp2JdM1q4ar",
  "3AFcE2mbSSndcpYFgHoExSmjUc26ef2gQh",
  "3P6PzdfETr4275Gn3veLkCyDxA1jV8fHKm",
  "3HRExd8GKFskZC5inmVcpiyy9UWG7FVa6o",
  "3MP7yBGSW2gkXVRE8S84T2j4KVgPh3rEzv",
  "1K2fmE9hfhbRNSZoBvCBWZAvsS5idTUxBG",
  "3ES6pqCueDPCnC4hCqhhYuey6gyiRJZw6E",
  "3KvBX3jo69Qn8jHy44M33RYoeYcf8DdRBD",
  "3K26aMKmnrv97Pj6YiFcqiXk2LxeHfhnG3",
  "3BWP6ZQAhc4j5wR1b95zJAthJEFvhdees7",
  "3JuSgFrwnrNfuhvR4GpWAPmeJVot4xrEae",
  "1DKGRGJXGNLAtTeFb9SNPNHtrkZ87q7qKi",
  "361AkMKNNWYwZRsCE8pPNmoh5aQf4V7g4p",
  "33fWcMdmsB2Ey4CEbVWbjGFkuevBSyP9nG",
  "35aTjkBh4yeTypJsi9nuTdoMKHTsawKVgX",
  "3K35dyL85fR9ht7UgzPfd1gLRRXQtNTqE3",
  "3Q5dGfLKkWqWSwYtbMUyc8xGjN5LrRviK4",
  "3EPqGUw2q89pwPZ1UF8FJspE2AyojSTjdu",
  "3LhnVMcBq4gsR7aDaRr9XmUo17CuYBV4FN",
  "3F6bbvS1krsc1qR8FsbTDfYQyvkMm3QvmR",
  "3JHMz3mTna1gVCZSPp8NgRFiY7phkv5mA8",
  "32DaxSzUhLBHY2WGSWQYiBSHnRsfQZrrRp",
  "3MTRvM5QrYZHKo8gh5qKcrPK3RLjxcDCZE",
  "34pFGsSYbWEritXncW9unZtQQE9dKSvKku",
  "38ncxqt932N9CcfNfYuHGZgCyR85hDkWBW",
  "3MD3riFB6U8PykypF6qkvSj8R2SGdUDPn3",
  "3JUwAS7seL3fh5hxWh9fu3HCiEzjuQLTfg",
  "3EUjqe9UpmyXCFd6jeu69hoTzndMRfxw9M",
  "3QEjBiPzw6WZUL4MYMmMU6DY1Y25aVbpQu",
  "3N3YSDvp4cbhEgNGabQxTN39kEzJmwG8Ah",
  "3J19qffPT6mxQUcV6k5yVURGZtdhpdGr4y",
  "33KKjn4exdBJQkTtdWxqpdVsWxrw3LareG",
  "3GSXNXzyCDoQ1Rhsc7F1jjjFe7DGcHHdcM",
  "3QJyT8nThEQakbfqgX86YjCK1Sp9hfNCUW",
  "35hh9dg3wSvUJz9vFk1FsezLE5Fx3Hudk2",
  "3NDzzVxiLBUs1WPvVGRfCYDTAD2Ua2PvW4",
  "3DCCgmyKozcZkFBzYb1A2x8abZCpAUTPPk",
  "3MvQ4gThF4mmuo49p4dBNchcmFHBRZnYfx",
  "3FBgeJdhiBe22UoSpp51Vd8dPHVa2A4wZX",
  "3HQDRyzwm82MFmLWtmyikDM9JQEtVT6vAp",
  "31t4nEpcwyQJT1VuXdAoQZTT5givRDPsNP",
  "39AALn7eTjdPzLb99hHhD6F7J8QWB3R2Rd",
  "3LDbNuDkKmLae5r3a5icPA5CQg2Y8F7ogW",
  "3JLyyLbwciWAC6re87D7mRknXakR4YbnUd",
  "3ANWhUnHujdwbw2jEuGSRH6bvFsD9BqEy9",
  "32fbAZMTaQxNd2fAue1PgsiPgWfcsHBQQt",
  "3HupEUfKmMhvhXqf8TMoPAyqDcRC1kpe65",
  "34kEYgpijvCmjvahRXXQEnBH76UGJVx2wg",
  "3GYbbYkvqvjF5oYhaKCgQYCvcVE1JENk6J",
  "3BazbaTP8ELJUEfPBV9z5HXEdgBziV9p7W",
  "3GMfGEDYMTq9G8dEHet1zLtUFJwYwSNa3Y",
  "38LjCapRrJEW7w2zwbyS15P9D9UGPjWS44",
  "36XqYWGvUQwBrYLRVuegN4pJJJSPWL1WEu",
  "37g6WgqedzZx6nx51tYgssNG8Hnknyj5nL",
  "3QAdoc1rDCt8dii1GVPJXvvK6CEJLzCRZw",
  "32PsiT8itBrEF84ebdaF82yBUEcz5Wc6uY",
  "3B4G1M8eF3cThbeMwhEWkKzczw9QoNTGak",
  "34ETiHfQWEYFCCaXmEeQWVmhFH5vz2JMvd",
  "3PyzSbFj3hbQQjTzDzyLSgvFVDjB7yw4Cj",
  "15PggTG7YhJKiE6B16vkKzA1YDTZipXEX4",
  "1H939dom7i4WDLCKyGbXUp3fs9CSTNRzgL",
  "TX5GV4DyfxNB3rPkzZJhmqZ1efVmL4rEqG",
  "1DbvK8P6imBuLcwh2Vruis4xsUb8YAwJQF",
  "1G6DuwDKNHiUWqks2Lgu44cesu7ffFbLK7",
  "3AQSmMk5n3c6TKEg9B2WyzYAPm33gJJAA4",
  "129zKFLoVad9JtxSmDKeJoLCsjhGR7b3vr",
  "12YyR9EpvHxBjjKjTWqfKqeyoWnvcraxpW",
  "1KctQENEX5QkQMpnMC3Zh9yRAzkMBLpPcr",
  "3HqA7i3ttECLvgqvq69HNxxUP5BL7Z5YgA",
  "1G9A8WRjGXdnYY4TNEVRrcaHsMtana4ncF",
  "1Js6goCey2NaqPQptiLANLQGuk4d6mowjP",
  "13RH4JaFhaCxDGPyYE9emjp2aDxdX18uBA",
  "1FE2cuvkq8n5VGwj5hi8YYQxskwJpovPyV",
  "1DJoEMvp95yJYWyxAZy8DDBzuvjnrTVrsN",
  "1N6XqSf3ULpNjko9LrJmHudRoLitjwkETN",
  "386wa1UM6nA798AWNh64jdrejZyedeXgUN",
  "15UdZbmGPa2LatD3abtGpphgkHLFWftV4R",
  "16tByCYzxuWiN8kF9FrK9jJy6eQYLVkQ1i",
  "1NpHuti9NSM9fVTXLkvSDU4AnhqGQ5N53d",
  "1LpYKb3SXZPve9hsH2QEJZFX279wJVGowi",
  "15uqdxqNXQwVf5H7yZPz4TmEGeSccCwdor",
  "1FjubFHV4mpYjBmvjsEhZssyiiA4TNmnm2",
  "1LAh7PQwpd1uGiLHae5C5Xz9QXse3y2phq",
  "15yqWQ4sqr7jzCwDtZ3U1KaCa8WMEy7Mm2",
  "19GrL5jnUkGmHXVcraB1Etv5rXCANeLWpq",
  "39NG2LcGRHXxSr1irpEVnJMw4ydL231sEn",
  "3He6EyDaCUgmdr4GXqhxbeTQukaGLCByU2",
  "12NpCkhddSNiDkD9rRYUCHsTT9ReMNiJjG",
  "32jgFkZsTEjMFaBvxJnYvJEeTNKTmq5b32",
  "1Hpj6qm9i7nMF3VkKfBFtjhEDpEjxHWvgv",
  "194xmrZA53UBsZau2PnJLdmVVW9m5feeS",
  "361NP7YcBPQ4KkLT3Y2QZeDEV4M3yi65Ar",
  "1LuDiMd95Df4i2bcvrfw47t2GKpLLXAQMZ",
  "3A1HH3PseYMkh2nSrBb4kkVt3815kUNVVC",
  "1F317n2eJEMaEMGiwCqtd5XCU3wF7jzPEW",
  "3HWjh69cVQvcPeLWVCyVmXEq72nyDSj5zP",
  "1r6S9vpUZPS5rb6gSdwV2bvSFcN3uSq4q",
  "3Jpf9B5P8cvEKSSGp9cES3Upbms8VRnXUb",
  "3EL5vcYeu1cnivLtR7tnAX3bBirr9ATNAL",
  "1LBQd4ZxtQYYsDWrCzK4uMxHBJVxmyzs3M",
  "1LQV6yUBcfTjAWvFu3XPhdTgjqihss7i1z",
  "1MiQRekg4BatJ12qbiSGnNakLLd8xbLMCG",
  "12mNKr2YP4M3CEQvCvVqZsvxuCG47LHMu1",
  "1J6cgUVEZRKyJhpXJgHWX7YmzkdnHRaLhF",
  "3PUmTuVAW3LkKg53FZ7F97VDBitW4ugwnM",
  "3H4qaWi5DS6FMwyZrG9xRRud3Qc5dUVn2U",
  "13ViCDZyJxxv5cZzpDDsE7aDQ3Y552zpAH",
  "1Juv2Ks3jJFUes8jEGxwgt6T6csBRQmmRw",
  "35vypiSvQsxRiT3YZzGRGVaduUSx67ysZb",
  "3LLUnf3ezw6mCbQ2zCZmGu5rZULzkhxQi7",
  "3QrukkUiBrn23rFUKUgasNd1wYWNk7WdSV",
  "3B3vmabBbeDRnVrjvvq3hm85zVB4v5bWFC",
  "31nadacWrgPeAQxKRMabhn3fPhnhi3hjKa",
  "343w3Xh64q5UpgpvAPqmsUzxrknde8PQHb",
  "1C7RpJNE19HgefzWVCSaUqRTHAwGAFkbYV",
  "3PKiHs4GY4rFg8dpppNVPXGPqMX6K2cBML",
  "1986rYHckYbJpGQJy6ornuMyD2N5MTqwDt",
  "125W5ek3DT6Zqy5S2iPt4FHQdNMCbZA3FU",
  "1Kc6egXevyLEaeTxLFA1Zyw7GuhCN8jQtt",
  "12w6v1qAaBc4W8h8C2Cu5SKFaKDSv3erUW",
  "1CPJak9ZyddbawMGJPyEhCiJLXXb4sYv8N",
  "1DJoVLgn1foJHHngduRPJvRbwpaFEKxvxd",
  "15kZobLkD6HZgEECtz4oS2Vz21XHTnNfSg",
  "15qyVrZvvVGvB7GWiAZ82TNcZ6QWMKu3kx",
  "12YCfVAEzkEZXBYhUTyJJaRkgMXiFxJgcu",
  "1MkCnCa9agS5t6V1B15bzusBgYECB4LfWp",
  "1NuBZQXJPyYQGfoBib8wWBDpZmbtkJa5Ba",
  "14rjAD8ZP5xaL571cMRE98qgxxbg1S8mAN",
  "18yWCu6agTxYqAerMxiz9sgHrK3ViezzGa",
  "12jVCWW1ZhTLA5yVnroEJswqKwsfiZKsax",
  "1J378PbmTKn2sEw6NBrSWVfjZLBZW3DZem",
  "18aqbRhHupgvC9K8qEqD78phmTQQWs7B5d",
  "16ti2EXaae5izfkUZ1Zc59HMcsdnHpP5QJ",
  "1D6gG9iKEhPitTcWRJiniuj1jYM2hNeAfJ",
  "1FCNgfZWpYMeYhy9t18AAkTBu8AsdoAc1Z",
  "1NaRX1GZgtZ7E8iXo8YUdTtnb8rAK5QFJa",
  "LNf2JDiuunBz7GMDKFYHN4rq5meXWxiwfb",
  "TBHTJqAy4DhHhmT3dNceJYNRz4SdLofLre",
  "1JHdQHkBZiim1cb4hyUh2PbzEbbg6z2TrF",
  "TVacWx7F5wgMgn49L5frDf9KLgdYy8nPHL",
  "1Ljk8RNNabkZ9bfDYQBn98XfFozJhTjqcZ",
  "3685sEusmTwZBiKJ4cgV73EAhpVD1nbgbe",
  "39p8qWp1bkBNhi4vPpFTetKPtH7goqNDZf",
  "TEFph7dZoUN5233cGEzF6XFwRpjPF8fQDS",
  "TMGLqRQ4twjW8wJhVH1mQR7nUThpGHUsN3",
  "3B7S6zrgxQVQUHTU8wstM23tB9afE7ojuX",
  "TEAqwfMhXLaomXhZ8KeMhx3njGmQEDnsUR",
  "3NNcbBcMZokPB2JC2dxYuZrpgcetvyGeJn",
  "TMStbg5fgb4uTV7fK1gEYF9hKAzP3siPsG",
  "38TftW1heYPqvKbiAhT4ttNBqkUPpooXad",
  "TTKnV2S1295UrPr7N67Tp9ykNL7xX2Z4Uj",
  "3NU9zkD8CCVGVmYnNNSN7PbU9sSFQBm5UV",
  "TRBACioxdrdsYEZHvJWiUDZcMdBPpEe5Ub",
  "1MLPqwaFFUBZePTjpR3nxRoK19Cv9mPCc7",
  "3HePkztPU6UsdENxnyQHFrdZA6eVKeMtvz",
  "TUCsTq7TofTCJRRoHk6RvhMoS2mJLm5Yzq",
  "19D1iGzDr7FyAdiy3ZZdxMd6ttHj1kj6WW",
  "3Q8H2ZWMtc4R1M3mkmhnTjCoYKTeCFigDP",
  "TTgcTTNbNuFdbrhvbjMZVrdU5KALyzDaPw",
  "TGJVc32ig2u8tQsYMLE7KXHT5NDQroaVNU",
  "TXEsK1sEsKjZ1xtHitnyAAoqw3WLdYdRNW",
  "TH96tFMn8KGiYSLiwcV3E2UiaJc8jmcbz3",
  "TC4VsFHJdZ66BdwobZxkudVZBVmQZgCP65",
  "TQ5mpZPbQMSq2s1vSM3RJgiB1AsTsiTpFZ",
  "TXEaKf4rT3rMoD3Vuqnuhwr6vLq6BL5t33",
  "TGUPpmW2bAnMCLe5ih2CFisfCHk4gTFDsx",
  "TDwN1Eq62bqvVhfGAjdRRJjE46jsi5KNMV",
  "TM6Kix9wH8cYQ4rLpFifsQ4ddH3rPX3f8p",
  "TDprk9jeYPVm6khkBp1u7fwuyJcEJFrPWD",
  "TVn4q7L4fKEPbygi7UHq1CKfZxtbeuMV5q",
  "18gaXypKj9M23S2zT9qZfL9iPbLFM372Q5",
  "32pTjxTNi7snk8sodrgfmdKao3DEn1nVJM",
  "15cRqR3TXS1JehBGWERuxFE8NhWZzfoeeU",
  "1A7SKE2dQtezLktCY8peLsdAtkqxV9r1dC",
  "TWBAPzpPiZarfVsY2BLXeaLhNHurn4wkWG",
  "TFdTr9C3BqQrzKBXqSxJfAZFTh8UwBAfSg",
  "13fhnkmpBBWXUQucJd6efWvXdEj78DKavk",
  "TLM3zA3EWycoDX4ZX4gKze7sgfbdkntTum",
  "13JtX4h7G5ZuNK5mFudKGq9DHLvvMFuNuz",
  "TTUDyVhhpCC1xJoPmWzdjLAzeoPwbSABdr",
  "M8yFL6SFC6TreATegTyuSYkDfDRbisdpT3",
  "TDdbRFoBTEmE3qiR69Y6rKRSG1hoF65QaE",
  "1M5N4sJ1NHb4fviLVZA5MZLKhLZqU4CPZz",
  "1Gekw8ACSs37oXcc5XQHvoux3iKoVFtpF4",
  "3FfRvC3kSo2SxiQe5e7SSuNdegwgq8iusL",
  "3FgaJMgxCfU3qqQ3Yiqv3Xw8rmLDDkByeo",
  "3EQoMXw6Xi8zNzY8tLfJbkWjV5EXsQP4Es",
  "37KHumAdzFcg1fXMv36UGg91MHPqhJUv19",
  "3GBGnqDqdiskCmfq2Rchk1LcBoSo4P3DZQ",
] as const

const BANNED_ADDRESSES_MAP = new Map(
  BANNED_ADDRESSES.map((address) => [address.toLowerCase(), address]),
)

export const isBannedAddress = (address: string): boolean => {
  const lowerCaseAddress = address.toLowerCase()

  const exists = BANNED_ADDRESSES_MAP.has(lowerCaseAddress)

  if (!exists) return false

  const tallyVersionOfAddress = BANNED_ADDRESSES_MAP.get(lowerCaseAddress)

  return isSameAddress(tallyVersionOfAddress, address)
}
